import { ReactNode } from "react";
import Icon from "../icons/icon";
import ArrowLeft from "../icons/lib/arrow-left";

interface TitleBarMobileProps {
  title?: string;
  left?: ReactNode;
  right?: ReactNode;
  allowBack?: boolean;
  onBack?: Function;
  className?: string;
}

const TitleBarMobile = ({
  title,
  right,
  left,
  allowBack = true,
  onBack,
  className,
}: TitleBarMobileProps) => {
  return (
    <div
      className={`flex justify-between items-center w-full h-[70px] mb-5 lg:mt-7 bg-background ${
        className ?? ""
      }`}
    >
      {!left ? (
        <div className="flex items-center gap-3">
          {allowBack && (
            <Icon
              id="titlebar-icon-back"
              onClick={() => allowBack && onBack && onBack()}
              icon={ArrowLeft}
              color="gray"
              className="h-[30px] w-[30px] z-10"
            />
          )}
          {title && (
            <p className="text-xl  flex text-start truncate">{title}</p>
          )}
        </div>
      ) : (
        left
      )}

      {right}
    </div>
  );
};

export default TitleBarMobile;
